import React from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";

export default function NotFoundPage() {
    React.useEffect(() => {
        document.title = "Page Not Found — Endurance Casualty Insurance Agency";
    }, []);
    return (
        <PageShell testId="page-404" title="Page not found" kicker="Error 404">
            <p>
                The page you were looking for could not be found. It may have
                been moved, renamed, or no longer exists.
            </p>
            <p>
                <Link to="/">Return to the home page →</Link>
            </p>
        </PageShell>
    );
}
